module.exports = __webpack_public_path__ + "93ac7c1b329e5539617d52e49f2a32a5.png";